import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getKetInformation = async ({ companyCode, employeeCode }) => {
  if (!companyCode || !employeeCode) return [];
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetKetInformation}?CompanyCode=${companyCode}&EmployeeCode=${employeeCode}`
  );
  return data;
};

const updateKetInformation = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.UpdateKETInformation,
    input
  );
  return data;
};

const generateKetForm = async ({ employeeCode, companyCode }) => {
  if (companyCode && employeeCode !== 0) {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GenerateKETForm}?EmployeeCode=${employeeCode}&CompanyCode=${companyCode}`
    );
    return data;
  }
  return [];
};

export const useInsertKetInformationMutation = () => {
  return useMutation({
    mutationFn: updateKetInformation,
  });
};

export const useGenerateKetFormQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GenerateKETForm],
    queryFn: () => generateKetForm(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetEmpKetInformationQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetKetInformation],
    queryFn: () => getKetInformation(input),
  });
};
